import { render, staticRenderFns } from "./InventoryProduct.vue?vue&type=template&id=7032622b&scoped=true"
import script from "./InventoryProduct.vue?vue&type=script&lang=ts"
export * from "./InventoryProduct.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.33_css-loader@6.11.0_webpack@5.106.2__ejs@3.1._76e9b4b2772e69f80f08b9c9843f568a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7032622b",
  null
  
)

export default component.exports